var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93.421,
    height: 132.439,
    viewBox: "0 0 93.421 132.439",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Insight_Icon",
    "data-name": "Insight Icon",
    transform: "translate(47.817 2.974)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-lightbulb-outline",
    "data-name": "Icon material-lightbulb-outline",
    d: "M12.785,29.012a1.377,1.377,0,0,0,1.373,1.373h5.494a1.377,1.377,0,0,0,1.373-1.373V27.638H12.785v1.373Zm4.12-26.095a9.61,9.61,0,0,0-5.494,17.5v3.1a1.377,1.377,0,0,0,1.373,1.373h8.241A1.377,1.377,0,0,0,22.4,23.518v-3.1a9.61,9.61,0,0,0-5.494-17.5ZM20.82,18.162l-1.167.824v3.159H14.159V18.986l-1.167-.824a6.867,6.867,0,1,1,7.828,0Z",
    transform: "translate(5.12 10.023)",
    fill: "aqua"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x1: 5.618,
    y1: 6.866,
    transform: "translate(22.55 0) rotate(40)",
    fill: "none",
    stroke: "aqua",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x1: 6.242,
    y1: 5.618,
    transform: "translate(7.01 4.587)",
    fill: "none",
    stroke: "aqua",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    y1: 5.93,
    x2: 7.323,
    transform: "translate(30.307 4.527)",
    fill: "none",
    stroke: "aqua",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    y1: 0.361,
    x2: 10.083,
    transform: "translate(33.969 16.97)",
    fill: "none",
    stroke: "aqua",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x1: 8.68,
    y1: 0.492,
    transform: "translate(0 16.346)",
    fill: "none",
    stroke: "aqua",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-file",
    "data-name": "Icon feather-file",
    transform: "translate(-46.359 37.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4355",
    "data-name": "Path 4355",
    d: "M46.669,2.917H14.908a9.075,9.075,0,0,0-9.075,9.075v72.6a9.075,9.075,0,0,0,9.075,9.075H69.356a9.075,9.075,0,0,0,9.075-9.075V34.678Z",
    transform: "translate(-5.833 -2.917)",
    fill: "none",
    stroke: "aqua",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.917
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4356",
    "data-name": "Path 4356",
    d: "M18.958,2.917V34.678H50.719",
    transform: "translate(21.877 -2.917)",
    fill: "none",
    stroke: "aqua",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.917
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/Icon3.70cf662ef7478896d7d3cb034d7957c5.svg";
export { ForwardRef as ReactComponent };